import * as i from 'io-ts';
import { String } from 'effect';
export const ProductFilters = i.record(i.string, i.array(i.string));
export const toApiProductFilters = (filterStr) => {
    const indvFilters = filterStr?.trim().split(',');
    if (indvFilters === undefined)
        return undefined;
    const apiFilters = {};
    indvFilters.forEach(f => {
        const keyVal = f.trim().split(':');
        const key = keyVal[0];
        const value = String.replaceAll(`"`, '')(keyVal[1]);
        if (!apiFilters[key]) {
            apiFilters[key] = [];
            apiFilters[key].push(value.trim());
        }
        else {
            apiFilters[key].push(value.trim());
        }
    });
    return apiFilters;
};
